<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="select">
      <FormItem>
        <Select
          v-model="searchFrom.mappingType"
          filterable
          clearable
          placeholder="Please Select Type"
        >
          <Option
            v-for="(item, index) in typeList"
            :value="index"
            :key="index"
            >{{ item[$i18n.locale] }}</Option
          >
        </Select>
      </FormItem>
    </template>
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>
    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('standard_role')" prop="mapping_id">
            <Select
              v-model="dataDetails.mapping_id"
              filterable
              :disabled="disabled"
              placeholder="Please Select Mapping"
            >
              <Option
                v-for="item in objMapping"
                :value="item.role_id"
                :key="item.role_id"
                >{{ item.standard_role }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('type')" prop="mapping_type">
            <Select
              v-model="dataDetails.mapping_type"
              filterable
              :disabled="disabled"
              placeholder="Please Select Type"
            >
              <Option
                v-for="(item, index) in typeList"
                :value="index"
                :key="index"
                >{{ item[$i18n.locale] }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('mapping_rule')" prop="rule">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.rule"
              placeholder="Please Enter Rule"
            ></i-Input>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { getMapping, add, del, update, getDetails } from "@/api/system/mapping";
import common from "_c/common-body";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";

export default {
  name: "mapping",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        mappingType: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        mapping_type: [
          {
            required: true,
            message: "mapping_type cannot be empty",
            trigger: "change",
          },
        ],
        rule: [
          {
            required: true,
            message: "rule cannot be empty",
            trigger: "blur",
          },
        ],
        mapping_id: [
          {
            type: "number",
            required: true,
            message: "mapping_name cannot be empty",
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      objMapping: {},
      typeList: {
        NR: { "zh-CN": " 无人接听", "en-US": "No one heard" },
        AE: { "zh-CN": " 地址错误", "en-US": "wrong address" },
        AN: { "zh-CN": " 地址不清晰", "en-US": "Unclear address" },
        ND: { "zh-CN": " 预约派送", "en-US": "Appointment delivery" },
        TE: { "zh-CN": " 电话错误", "en-US": "Phone error" },
        CR: { "zh-CN": " 拒签", "en-US": "Refusal" },
        OS: { "zh-CN": " 超出服务区", "en-US": "Out of service area" },
      },
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("type"),
        key: "type_name",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("standard_role"),
        key: "rolemap_name",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("mapping_rule"),
        key: "rule",
        align: "center",
        minWidth: 150,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 280,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList(this.searchFrom);
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
      } else {
        if (this.crudText === "delete") {
          console.log(this.delId);
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.objMapping = basic.objRoleMapping();
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getMapping(data)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map((item) => {
            let rolemap = nodata.noData(
              basic.objRoleMapping(),
              item.mapping_id,
              "rolemap"
            );
            item.rolemap_name = rolemap.name;
            item.type_name = this.typeList[item.mapping_type][
              this.$store.state.app.local
            ];
            return item;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      delete this.dataDetails.country;
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
